import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElBannerImage, ElImage } from "./banner-image.css";
interface IBannerImageProps extends HTMLAttributes<HTMLElement> {}

export const BannerImage: FC<IBannerImageProps> = ({ children, ...props }) => {
  return (
    <ElBannerImage {...props}>
      <ElImage src={Images.design.banner} />
    </ElBannerImage>
  );
};
